
import dust from "dustjs-linkedin";


(function(){dust.register("feedback/post-feedback",body_0);function body_0(chk,ctx){return chk.write("<header><h1>").helper("i18n",ctx,{},{"collection":"feedback_post_feedback_title","id":ctx.get(["category"], false)}).write("</h1></header><main><p>").helper("i18n",ctx,{},{"collection":"feedback_post_feedback_message","id":ctx.get(["category"], false)}).write("</p></main><footer><button class=\"outline close\">").helper("i18n",ctx,{},{"id":"feedback_post_feedback_button_close"}).write("</button></footer>");}return body_0;})();

export default 0;
